<template>
  <img src="/imgs/mpay.png" class="w-6 h-6 inline-block" />
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
